module.exports = __webpack_public_path__ + "img/carone.01f64638.png";